import React from 'react'
import styled from '@emotion/styled'
import { mediaQueriesByDevice } from 'parameters/viewport'
import { BlockComponent } from 'lib'
import { GridGroup } from 'experiences/dashboard/DashboardRoot/grid/GridGroup'
import { DashboardGroup } from '../lib/types'

interface Props {
	content: Array<DashboardGroup>
}

export const DashboardGrid: BlockComponent<Props> = ({ content }) => {
	return (
		<Grid>
			{content.map(group => {
				return <GridGroup group={group} key={group.key} />
			})}
		</Grid>
	)
}

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	grid-auto-rows: 380px;
	grid-gap: 32px;
	margin-bottom: 32px;

	${mediaQueriesByDevice.laptop} {
		grid-template-columns: repeat(3, 1fr);
	}

	${mediaQueriesByDevice.tablet} {
		grid-template-columns: repeat(2, 1fr);
	}

	${mediaQueriesByDevice.mobile} {
		grid-template-columns: 1fr;
		grid-template-rows: unset;
		grid-auto-rows: unset;
		margin: 0 -20px;
		grid-gap: 0;
	}
`
